module.exports = __webpack_public_path__ + "img/warning-triangle-icon.4e67a9d3.svg";